// extracted by mini-css-extract-plugin
export default {"mobileContainer":"Mobile_mobileContainer__0eYbU","mobile":"Mobile_mobile__lyX1P","mobileScreen":"Mobile_mobileScreen__z0jW6"};